export default __webpack_public_path__ + "static/media/ssapMarket.777c6b3e.svg";